export default {
  "content": "<path d=\"M7.5 1v12m-6-6h12\" stroke=\"#ff00cb\" stroke-opacity=\".9\" stroke-width=\"2\" stroke-linecap=\"round\"/>",
  "attrs": {
    "width": "15",
    "height": "14",
    "viewBox": "0 0 15 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};